/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Pvagzuschuss3Inputs */



/**

* @param {_Field_Pvagzuschuss3Inputs} inputs
* @param {{ locale?: "de" }} options
* @returns {LocalizedString}
*/
const _field_pvagzuschuss3 = /** @type {((inputs?: _Field_Pvagzuschuss3Inputs, options?: { locale?: "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Pvagzuschuss3Inputs, { locale?: "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return /** @type {LocalizedString} */ ("PV-AG-Zuschuss")
});
export { _field_pvagzuschuss3 as "_field_pvAGZuschuss" }